import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, Tag } from "antd";
import SoftButton from "StyleFeatures/SoftButton";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import Footer from "Common/Footer";

function Skills({
   onNext = () => {},
    onBack = () => {}, 
    employeeDetail = {},
  departmentId
  }) {
  const [skillsList, setSkillsList] = useState([]);
  const [selectedSkillIds, setSelectedSkillIds] = useState([]);
  const [customSkills, setCustomSkills] = useState([]);
  const [customSkillInput, setCustomSkillInput] = useState("");
  const [formErrors, setFormErrors] = useState({ skillError: "" });

  // Fetch skills
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const res = await axiosInstance.get(API.skills.getListByDept(departmentId));
        setSkillsList(res.data || []);
      } catch (error) {
        console.error("Error fetching skills list", error);
      }
    };

    fetchSkills();
  }, []);

  // Restore edit values
  useEffect(() => {
    if (employeeDetail?.skills) {
      setSelectedSkillIds(employeeDetail.skills.skillIds || []);
      setCustomSkills(employeeDetail.skills.customSkills || []);
    }
  }, [employeeDetail]);

  // Add dropdown skill as tag
  const handleSelectSkill = (e) => {
    const skillId = Number(e.target.value);

    if (!skillId) return;

    if (!selectedSkillIds.includes(skillId)) {
      setSelectedSkillIds([...selectedSkillIds, skillId]);
    }

    e.target.value = "";
  };

  // Add custom skill
  const addCustomSkill = () => {
    const skill = customSkillInput.trim();

    if (!skill) return;

    if (!customSkills.includes(skill)) {
      setCustomSkills([...customSkills, skill]);
    }

    setCustomSkillInput("");
  };

  // Remove selected skill
  const removeSkill = (id) => {
    setSelectedSkillIds(selectedSkillIds.filter((skill) => skill !== id));
  };

  // Remove custom skill
  const removeCustomSkill = (skill) => {
    setCustomSkills(customSkills.filter((s) => s !== skill));
  };

  // Submit
  const handleNext = () => {
    if (employeeDetail.isSubmitting) return;

    if (selectedSkillIds.length === 0 && customSkills.length === 0) {
      setFormErrors({ skillError: "Please add at least one skill." });
      return;
    }

    setFormErrors({ skillError: "" });

    const payload = {
      skillIds: selectedSkillIds,
      customSkills,
    };
    onNext(payload);
  };

  return (
    <div className="body flex-grow-1 px-3">
      <Card title="Skills" className="card-professional">
        <h5 className="fw-bold mb-4">Step 4: Select Skills</h5>
        <div className="row">
          {/* Skill Dropdown */}
          <div className="col-md-6 mb-4">
            <label className="form-label">Select Skill</label>
            <select className="form-select" defaultValue="" onChange={handleSelectSkill}>
              <option value="">Select skill</option>
              {skillsList.map((skill) => (
                <option key={skill.id} value={skill.id}>
                  {skill.name}
                </option>
              ))}
            </select>

            {formErrors.skillError && (
              <div className="text-danger mt-2">{formErrors.skillError}</div>
            )}
          </div>
          {/* Custom Skill */}
          <div className="col-md-6 mb-4">
            <label className="form-label">Add Custom Skill</label>
            <div style={{ display: "flex", gap: "8px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Type skill"
                value={customSkillInput}
                onChange={(e) => setCustomSkillInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addCustomSkill();
                  }
                }}
              />
              <SoftButton className="btn-back" onClick={addCustomSkill} size="small">
                Add
              </SoftButton>
            </div>
          </div>
        </div>
        {/* Tags Display */}
        <div style={{ marginTop: "10px" }}>
          {selectedSkillIds.map((id) => {
            const skill = skillsList.find((s) => s.id === id);

            return (
              <Tag key={id} closable color="blue" onClose={() => removeSkill(id)}>
                {skill?.name}
              </Tag>
            );
          })}

          {customSkills.map((skill) => (
            <Tag key={skill} closable color="green" onClose={() => removeCustomSkill(skill)}>
              {skill}
            </Tag>
          ))}
        </div>

        {/* Buttons */}
        <div style={{ marginTop: "25px" }}>
          <SoftButton onClick={onBack} className="btn-back" style={{ marginRight: "10px" }}>
            Back
          </SoftButton>

          <SoftButton
            onClick={handleNext}
            className="btn-primary"
            disabled={employeeDetail.isSubmitting} // pass isSubmitting from parent
          >
            {employeeDetail.isSubmitting ? "Submitting..." : "Submit"}
          </SoftButton>
        </div>
      </Card>

      <Footer />
    </div>
  );
}

Skills.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  employeeDetail: PropTypes.object,
  departmentId: PropTypes.number,
};

export default Skills;
